import { useRootSelector } from './root-selector.hook';

export const useClient = () => useRootSelector(state => state.configuration.value);
